// extracted by mini-css-extract-plugin
export default {"results":"_58dc162e"};